import React from "react";
import "./style.css"

function Footer() {
  const year = new Date().getFullYear();

  return (
    <div className="footer">
      <p>
        ChainIntel<span>.</span>
      </p>
      <small>© {year} ChainIntel. All rights reserved.</small>
    </div>
  );
}

export default Footer;
